const getInitialState = () => {
  return [];
};

const handleInit = (state, action) => {
  return [...state, action.form];
};

const handleClose = (state, action) => {
  const forms = state.filter(
    form => form.instanceToken !== action.instanceToken
  );

  return forms;
};

const handleUpdate = (state, action) => {
  const formIndex = state.findIndex(
    form => form.instanceToken === action.form.instanceToken
  );

  if (formIndex === -1) return state;

  const form = state[formIndex];
  const { fields } = form;

  let updatedFields = {};

  if (fields) {
    Object.keys(fields)
      .concat(Object.keys(action.form.fields))
      .forEach(fieldId => {
        updatedFields[fieldId] = {
          ...fields[fieldId],
          ...action.form.fields[fieldId]
        };
      });
  } else {
    updatedFields = action.form.fields;
  }

  const { actions } = form;
  let updatedActions = {};


  // TODO: refactoring
  if (action.form.actions) {
    if (actions) {
      Object.keys(actions)
        .concat(Object.keys(action.form.actions))
        .forEach(actionId => {
          updatedActions[actionId] = {
            ...actions[actionId],
            ...action.form.actions[actionId],
            isProcessing: action.form.actions[actionId] ? action.form.actions[actionId].isProcessing : false
          };
        });
    } else {
      updatedActions = action.form.actions;
    }
  } else {
    updatedActions = actions;
  }

  return [
    ...state.slice(0, formIndex),
    {
      ...state[formIndex],
      actions: updatedActions,
      fields: updatedFields,
      params: { ...form.params, ...(action.form.params || {}) },
      errors: action.form.errors || form.errors
    },
    ...state.slice(formIndex + 1)
  ];
};

const formsReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case 'FORM_INIT':
      return handleInit(state, action);
    case 'FORM_CLOSE':
      return handleClose(state, action);
    case 'FORM_UPDATE':
      return handleUpdate(state, action);
    default:
      return state;
  }
};
export default formsReducer;



// WEBPACK FOOTER //
// ./src/store/forms/forms.js